import $ from 'jquery';
class Filter {
	constructor(data, keys = ['name', 'number']) {
		this.data = data;
		this.keys = keys;

		this.set = {
			input: new Set(),
			initial_str: new Set(),
			initial_num: new Set(),
			initial_alphabet: new Set()
		};
	}

	getSetData() {
		return this.set;
	}

	addVal(ary) {
		this.set.input.clear();

		for (let i = 0, l = ary.length; i < l; i++) {
			this.set.input.add(ary[i]);
		}
	}

	clearVal() {
		this.set.input.clear();
	}

	addInitialStr(str) {
		this.set.initial_str.add(str);
	}

	deleteInitialStr(str) {
		this.set.initial_str.delete(str);
	}

	addInitialNum(str) {
		this.set.initial_num.add(str);
	}

	deleteInitialNum(str) {
		this.set.initial_num.delete(str);
	}

	addInitialAlphabet(str) {
		this.set.initial_alphabet.add(str);
	}

	deleteInitialAlphabet(str) {
		this.set.initial_alphabet.delete(str);
	}

	getResult() {
		let result = [];
		let set = new Set();
		let process = this.data.concat([]);
		let is_filter = false;

		// 検索フォームのテキストでフィルター
		if (this.set.input.size > 0) {
			is_filter = true;
			var aaa = 0;
			process.forEach(val => {
				this.set.input.forEach(input_str => {
					let str = input_str;
					const han = str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {
						return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
					});
					if (input_str.match(/[Ａ-Ｚａ-ｚ０-９]/g)) str = han;
					for (let i = 0, l = this.keys.length; i < l; i++) {
						if (val[this.keys[i]].toUpperCase().indexOf(str.toUpperCase()) > -1) set.add(val);
					}
				});
			});
		}

		// イニシャルでフィルター
		if (this.set.initial_str.size > 0) {
			is_filter = true;
			const keyJa = {
				ア: ['ア', 'イ', 'ウ', 'エ', 'オ'],
				カ: ['カ', 'キ', 'ク', 'ケ', 'コ', 'ガ', 'ギ', 'グ', 'ゲ', 'ゴ'],
				サ: ['サ', 'シ', 'ス', 'セ', 'ソ', 'ザ', 'ジ', 'ズ', 'ゼ', 'ゾ'],
				タ: ['タ', 'チ', 'ツ', 'テ', 'ト', 'ダ', 'ヂ', 'ヅ', 'デ', 'ド'],
				ナ: ['ナ', 'ニ', 'ヌ', 'ネ', 'ノ'],
				ハ: ['ハ', 'ヒ', 'フ', 'ヘ', 'ホ', 'バ', 'ビ', 'ブ', 'ベ', 'ボ', 'パ', 'ピ', 'プ', 'ペ', 'ポ'],
				マ: ['マ', 'ミ', 'ム', 'メ', 'モ'],
				ヤ: ['ヤ', 'ユ', 'ヨ'],
				ラ: ['ラ', 'リ', 'ル', 'レ', 'ロ'],
				ワ: ['ワ', 'ヲ'],
				ン: ['ン']
			};
			process.forEach(val => {
				this.set.initial_str.forEach(initial => {
					if ($('body').hasClass('lang-ja')) {
						// console.log(val[this.keys[0]][0].toUpperCase());
						if (keyJa[initial].indexOf(val[this.keys[0]][0].toUpperCase()) >= 0) {
							set.add(val);
						}
					} else {
						if (val[this.keys[0]][0].toUpperCase() === initial) set.add(val);
					}
				});
			});
		}

		// イニシャル数字でフィルター(数字ならなんでもOK)
		if (this.set.initial_num.size > 0) {
			is_filter = true;
			process.forEach(val => {
				if (val[this.keys[0]][0].search(/^[0-9]+$/) > -1) set.add(val);
			});
		}

		// イニシャルアルファベットでフィルター(アルファベットならなんでもOK)
		if (this.set.initial_alphabet.size > 0) {
			is_filter = true;
			process.forEach(val => {
				if (val[this.keys[0]][0].search(/^[a-zA-Z]+$/) > -1) set.add(val);
			});
		}

		if (is_filter) {
			for (let value of set.values()) {
				result.push(value);
			}
		} else {
			result = this.data.concat([]);
		}

		return result;
	}
}

export default Filter;



// WEBPACK FOOTER //
// ./src/js/app/Filter.js